export default {
  'h_one': 'Chain Explorer',
  'tit_one': 'Testnet',
  'tit_two': 'Mainnet',
  'HyperchainSpaceHeight': 'Hyper Block Height',
  'SpaceHeight':'Height',
  'Nodes': 'Nodes',
  'NodeMap': 'NodeMap',
  'Blockchains': 'Localchains',
  'Concurrency': 'Concur Peak',
  'HBlock': 'HBlock',
  'LChains': 'LChains',
  'Search': 'Search',
  'Tips': 'Example: Input [ 123,1,2 ] for Block ID，input Transaction hash as Transaction ID.',
  'Time': 'Time',
  'Blocks': 'Blocks',
  'Chains': 'Chains',
  'Next': 'Next',
  'Previous': 'Previous',
  'HyperBlock': 'HyperBlock',
  'LocalBlockId': 'LocalBlockId',
  'Localchains': 'Localchains',
  'BlockSize': 'Block Size',
  'BlockVersion': 'Block Version',
  'BlockHash': 'Block Hash',
  'PreviousBlockHash': 'Previous Block Hash',
  'Consensus': 'Consensus',
  'Difficulty': 'Weight',
  'Height': 'Height',
  'Size': 'Size',
  'Ver': 'Ver',
  'Payload': 'Payload',
  'Localchain': 'Localchain',
  'LocalBlock': 'Local Block',
  'PreviousLocalBlock': 'Previous Local Block',
  'PreviousLocalBlockHash': 'Previous Local Block Hash',
  'HyperblockHash': 'Hyperblock Hash',
  'RAW': 'Local Block Payload in RAW Format',
  'PayloadHash': 'Payload Hash',
  'PayloadSize': 'Payload Size',
  'More': 'More',
  'Fewer': 'Fewer',
  'Help': 'Help',
  'HyperBlockList': 'HyperBlocks',
  'LocalChainList': 'LocalChain List',
  'LocalBlockList': 'LocalBlock List',
  'LocalchainType': 'Localchain Type',
  'DApp': 'DApp',
  'HyperBlockMsg': 'HyperBlock',
  'LocalChainMsg': 'LocalChain',
  'LocalBlockMsg': 'LocalBlock',
  'Top':'Top',
  'mainnet_default': 'Not yet, please wait',
  'PreviousHyperBlock_hash': 'Previous Hyper Block Hash',
  'tx':'Transaction',
  'AppType': 'App Type',
  'T_token': 'Token',
  'T_coin': 'Coin',
  'T_default': 'Default',
  'Apps':'Apps',
  'AppName':'App Name',
  'PayloadRaw': 'Payload Raw',
  'PayloadParsed': 'Payload Parsed',
  'P_default': 'Unregnized Data Format,Require Data Parser',
  'SearchbyBlockIDTransactionID': 'Search by Block ID/Transaction ID/Address',
  'TxView': {
    'TxDetail': 'Transaction',
    From: 'From',
    Title: 'Transfer Details',
    Contract: 'Contract',
    TXID: 'TxID',
    From: 'From',
    Sender: 'Tx Sender', 
    TxAmount: 'Tx Amount',         
    Amount: 'Amount',
    State: 'Status',
    Pending: 'Pending',
    Failed: 'Fail',
    Confirmed: 'Confirmed',
    Token: 'Token',
    Time: 'Time',
    Receivers: 'Receivers',
    Receiver: 'Tx Receiver',
    TokenName: 'Token Name',
    NFTName: 'NFT Name',
    TokenLogo: 'Token Logo',
    BlockNo: 'Block ID',
    Data: 'Data',    
    Gas: 'Gas',
    Copied: 'Copied',
    Sign: 'Tx Sign',
    TXData: 'Tx Data',
    Mature: 'Mature'
  },
}